import React from "react";
import "./App.css";
import UserProvider from "./context/UserContext";
import FlagProvider from "./context/FlagContext";
import HeaderNavBar from "./navbar/NavBar";
import { useLocation } from "react-router-dom";
import LoginView from "./components/LoginView";
import { Route } from "react-router";
import FooterBar from "./navbar/FooterBar";
import BatchMaterialReport from "./components/BatchMaterialReport";
import { SecuredRoute } from "./auth/SecuredRoute";
import IssueForm from "./components/IssueForm";

function App() {
  return (
    <UserProvider>
      <FlagProvider>
    <div className={useLocation().pathname === "/" ? "loginbg_img" : null}>
      <div className="main">
        <HeaderNavBar />
        <div>
          <SecuredRoute exact path="/prod/bmr" component={BatchMaterialReport} />
          <SecuredRoute exact path="/prod/issue" component={IssueForm} />
          <Route exact path="/" component={LoginView} />
        </div>
      </div>
      <FooterBar />
    </div>
    </FlagProvider>
    </UserProvider>
  );
}

export default App;
